import { mat4 } from "gl-matrix";
import { Camera } from "../../../../SharedGL/Camera";
import { IRGBA } from "../../TimelineUtils";
import { FlightGL } from "../Flight/FlightGL";
import { StippledQuadShader } from "./StippledQuadShader";

interface IGLAttributes {
  position: WebGLBuffer;
}

export interface IHighlighColors {
  fill: IRGBA;
  outline: IRGBA;
}

export class StippledQuadGL {
  public static readonly referenceTime = new Date().getTime(); //Date.now();

  private shader: StippledQuadShader;

  private buffers: IGLAttributes;

  private positions: number[];

  constructor(gl: WebGLRenderingContext) {
    // super(gl);
    // Initialize a shader program; this is where all the lighting
    // for the vertices and so forth is established.

    // this.labelShaderProgram = initShaderProgram(gl, this.vsSource, this.fsSource);
    this.shader = new StippledQuadShader(gl);

    // Here's where we call the routine that builds all the
    // objects we'll be drawing.
    this.buffers = this.initBuffers(gl);
  }

  //
  // initBuffers
  //
  // Initialize the buffers we'll need. For this demo, we just
  // have one object -- a simple two-dimensional square.
  //
  protected initBuffers = (gl: WebGLRenderingContext): IGLAttributes => {
    // Create a buffer for the square's positions.

    const positionBuffer = gl.createBuffer();

    // Select the positionBuffer as the one to apply buffer
    // operations to from here out.

    gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);

    // Now create an array of positions for the square.
    const y0 = 0; // FlightGL.actualDepartureStart + rowStart; // this.aircraftActualFlightHeight;
    const y = 1; // FlightGL.actualDepartureHeight;// FlightGL.actualDepartureHeight; // rowStart + totalHeight -  FlightGL.aircraftRowPadding;
    const x0 = 0; // flight.x0 - Camera.referenceTime;
    const x = 1; // flight.x - Camera.referenceTime;
    this.positions = [x0, y0, x, y0, x, y, x0, y];

    // this.position(...flightPositions);

    // Now pass the list of positions into WebGL to build the
    // shape. We do this by creating a Float32Array from the
    // JavaScript array, then use it to fill the current buffer.

    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(this.positions), gl.STATIC_DRAW);

    return {
      position: positionBuffer,
    };
  };

  public draw = (gl: WebGLRenderingContext, camera: Camera, timePos: number[], yPos: number, color: IRGBA): void => {
    const vertexCount = this.positions.length / 2.0;
    if (vertexCount === 0 || timePos.length !== 2) {
      return;
    }

    this.shader.useProgram(gl);
    this.shader.bindPositionsBuffer(gl, this.buffers.position);

    const modelViewMatrix = mat4.create();

    const [x0, x] = timePos.map((val: number) => val - Camera.referenceTime);
    const width = x - x0;

    const height = FlightGL.aircraftRowHeight;

    mat4.translate(
      modelViewMatrix, // destination matrix
      modelViewMatrix, // matrix to translate
      [x0, yPos, -1.0]
    ); // amount to translate
    mat4.scale(modelViewMatrix, modelViewMatrix, [width, height, 1.0]);

    this.shader.setModelViewMatrix(gl, modelViewMatrix);

    // Outline
    this.shader.setColorUniform(gl, color);
    this.shader.draw(gl, camera, 0, 4);
  };
}
